/**
 * Throttles the provided function, limiting it to execute at most once every specified delay.
 *
 * @param func - The function to throttle.
 * @param delay - The delay period in milliseconds.
 * @returns A throttled version of the given function.
 */
let timeoutId = null;
function throttle(func, delay) {
    let lastExecutionTime = 0;
    return function (...args) {
        const now = Date.now();
        const timeSinceLastExecution = now - lastExecutionTime;
        if (timeoutId !== null) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }
        // If enough time has passed since the last execution, execute the function immediately
        if (timeSinceLastExecution >= delay) {
            lastExecutionTime = now;
            func.apply(this, args);
        }
        else {
            // Otherwise, set a timeout to execute the function after the remaining time
            timeoutId = setTimeout(() => {
                lastExecutionTime = Date.now();
                func.apply(this, args);
            }, delay - timeSinceLastExecution);
        }
    };
}
export default throttle;
